(function () {
  const onReady = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  onReady(() => {
    const menuButton = document.querySelector('[data-sb-menu-toggle], [data-sb-mobile-toggle]');
    const mobileMenu = document.querySelector('[data-sb-mobile-menu]');
    const setMenu = (open) => {
      document.body.classList.toggle('sb-menu-open', open);
      if (menuButton) menuButton.setAttribute('aria-expanded', String(open));
      if (mobileMenu) mobileMenu.setAttribute('aria-hidden', String(!open));
    };
    menuButton?.addEventListener('click', () => setMenu(!document.body.classList.contains('sb-menu-open')));
    mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

    const enhancedRevealSelectors = [
      '.s12-card',
      '.s12-category',
      '.s12-editorial',
      '.s12-manifesto',
      '.s12-feature-band',
      '.sbx-product-story__grid article',
      '.sbx-product-ritual li',
      '.sbx-kettle-video',
      '.sbx-kettle-detail__images img',
      '.sbx-kettle-specs article',
      '.sbx-kettle-care article',
      '.sbx-pitcher-detail__images img',
      '.sbx-pitcher-specs article',
      '.sbx-spray-video',
      '.sbx-spray-detail__images img',
      '.sbx-spray-specs article',
      '.sbx-cup-video',
      '.sbx-cup-detail__images img',
      '.sbx-cup-specs article',
      '.sbx-filter-detail__images img',
      '.sbx-filter-specs article',
      '.sbx-distribution-detail__images img',
      '.sbx-distribution-specs article',
      '.sbx-blower-detail__images img',
      '.sbx-blower-specs article',
      '.sbx-scale-detail__images img',
      '.sbx-scale-specs article',
      '.sb-care__path-grid > *',
      '.sb-care__row',
      '.sb-ship__policies article',
      '.sb-ship__fact'
    ];

    document.querySelectorAll(enhancedRevealSelectors.join(',')).forEach((item, index) => {
      item.classList.add('sb-enhanced-reveal');
      item.style.setProperty('--sb-reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
    });

    const revealItems = document.querySelectorAll('[data-sb-reveal], .sb-enhanced-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    } else revealItems.forEach((item) => item.classList.add('is-visible'));

    document.querySelectorAll('[data-sb-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const form = select.closest('form');
        const price = form?.closest('[data-sb-product]')?.querySelector('[data-sb-product-price]');
        const submit = form?.querySelector('[type="submit"]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (submit) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = available ? (submit.dataset.addLabel || 'Add to cart') : (submit.dataset.soldLabel || 'Sold out');
        }
      });
    });

    document.querySelectorAll('.s12-collection__body').forEach((collectionArea) => {
      const grid = collectionArea.querySelector('[data-sb-collection-grid]');
      if (!grid) return;

      const controls = Array.from(collectionArea.querySelectorAll('[data-sb-filter]'));
      const cards = Array.from(grid.querySelectorAll('[data-sb-product-card]'));
      const editorials = Array.from(grid.querySelectorAll('[data-sb-collection-editorial]'));
      const empty = collectionArea.querySelector('[data-sb-collection-empty]');
      const sortForm = collectionArea.querySelector('[data-sb-collection-sort]');
      const sortSelect = sortForm?.querySelector('select');

      cards.forEach((card, index) => {
        card.dataset.sbOriginalIndex = String(index);
        card.dataset.sbTitle = (card.dataset.sbTitle || card.textContent || '').trim().toLowerCase();
        card.dataset.sbPrice = String(Number(card.dataset.sbPrice || 0));
      });

      const getActiveFilter = () => {
        const active = controls.find((control) => control.classList.contains('is-active'));
        return active?.dataset.sbFilter || 'all';
      };

      const cardMatches = (card, filter) => {
        if (filter === 'all') return true;
        return (card.dataset.sbFilterCategories || '').split(/\s+/).includes(filter);
      };

      const sortCards = (items) => {
        const value = sortSelect?.value || '';
        const sorted = [...items];
        if (value === 'title-ascending') {
          sorted.sort((a, b) => a.dataset.sbTitle.localeCompare(b.dataset.sbTitle));
        } else if (value === 'title-descending') {
          sorted.sort((a, b) => b.dataset.sbTitle.localeCompare(a.dataset.sbTitle));
        } else if (value === 'price-ascending') {
          sorted.sort((a, b) => Number(a.dataset.sbPrice) - Number(b.dataset.sbPrice));
        } else if (value === 'price-descending') {
          sorted.sort((a, b) => Number(b.dataset.sbPrice) - Number(a.dataset.sbPrice));
        } else if (value === 'created-descending') {
          sorted.sort((a, b) => Number(b.dataset.sbOriginalIndex) - Number(a.dataset.sbOriginalIndex));
        } else {
          sorted.sort((a, b) => Number(a.dataset.sbOriginalIndex) - Number(b.dataset.sbOriginalIndex));
        }
        return sorted;
      };

      const renderCollection = () => {
        const filter = getActiveFilter();
        const visibleCards = sortCards(cards.filter((card) => cardMatches(card, filter)));
        const visibleSet = new Set(visibleCards);

        cards.forEach((card) => {
          card.hidden = !visibleSet.has(card);
        });

        editorials.forEach((editorial) => {
          editorial.hidden = filter !== 'all';
        });

        visibleCards.forEach((card, index) => {
          grid.appendChild(card);
          if (filter === 'all' && index === 2 && editorials[0]) {
            grid.appendChild(editorials[0]);
          }
        });

        if (filter !== 'all') {
          editorials.forEach((editorial) => grid.appendChild(editorial));
        } else if (editorials[0] && visibleCards.length < 3) {
          grid.appendChild(editorials[0]);
        }

        if (empty) empty.hidden = visibleCards.length > 0;
      };

      controls.forEach((control) => {
        control.addEventListener('click', (event) => {
          event.preventDefault();
          controls.forEach((item) => {
            item.classList.remove('is-active');
            item.removeAttribute('aria-current');
          });
          control.classList.add('is-active');
          control.setAttribute('aria-current', 'true');
          renderCollection();
        });
      });

      sortForm?.addEventListener('submit', (event) => event.preventDefault());
      sortSelect?.addEventListener('change', renderCollection);
      renderCollection();
    });

    document.querySelectorAll('.sbx-product-scale .s12-gallery, .sbx-product-kettle .s12-gallery, .sbx-product-pitcher .s12-gallery, .sbx-product-spray .s12-gallery, .sbx-product-cup .s12-gallery, .sbx-product-filter_box .s12-gallery, .sbx-product-distribution .s12-gallery, .sbx-product-blower .s12-gallery').forEach((gallery) => {
      const thumbs = Array.from(gallery.querySelectorAll('.s12-gallery__thumbs a'));
      if (!thumbs.length) return;
      thumbs[0].classList.add('is-active');

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
          const target = gallery.querySelector(thumb.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
    });
  });
})();
